import { render, staticRenderFns } from "./chaoxiang.vue?vue&type=template&id=75db0c0b&"
import script from "./chaoxiang.vue?vue&type=script&lang=js&"
export * from "./chaoxiang.vue?vue&type=script&lang=js&"
import style0 from "./chaoxiang.vue?vue&type=style&index=0&id=75db0c0b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports